<template>
  <div>
    <el-row class="panel-group" :gutter="40">
      <el-col :xs="12" :sm="12" :md="6" class="card-panel-col">
        <div v-if="loaded">
          <pie :chart-data="thisM" :title="'本月銷售'" />
        </div>
      </el-col>
      <el-col :xs="12" :sm="12" :md="6" class="card-panel-col">
        <div v-if="loaded">
          <pie :chart-data="lastM" :title="'上月銷售'" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getSaleChart } from '@/api/dashboard'
import { mapGetters, mapState } from 'vuex'
import pie from './pie.vue'
const type = {
  cash: '現金',
  ipass: '一卡通',
  easycard: '悠遊卡',
  creditcard: '信用卡'
}
function generateChart(thisChart, key) {
  const chart = {
    type: 'pie',
    radius: ['20%', '50%'],
    roseType: 'radius',
    data: null
  }
  const data = []
  if (thisChart) {
    for (const index in thisChart[key]) {
      data.push({ name: type[index], value: thisChart[key][index] })
    }
  }
  chart.data = data
  return chart
}
export default {
  components: { pie },
  data() {
    return {
      chart: null,
      loaded: false
    }
  },
  methods: {},
  computed: {
    ...mapState('variable', ['company_id']),
    thisM() {
      return generateChart(this.chart, 'thisM')
    },
    lastM() {
      return generateChart(this.chart, 'lastM')
    }
  },
  watch: {
    async company_id() {
      this.loaded = false
      this.chart = await getSaleChart({ company_id: this.company_id })

      this.loaded = true
    }
  },
  async created() {
    this.chart = await getSaleChart({ company_id: this.company_id })
    this.loaded = true
  }
}
</script>
